module.exports = __webpack_public_path__ + "img/1_fish.f969d357.jpg";